/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';

import { params } from '../../../../../redux/reducers/reducer';
import { convertFeet } from '../../../../../utils/ConvertFeet';

import LineModel from '../../LineModel';
import DimensionValue from '../../DimensionValue';

const LeftLeanToMeasurement = ({ color }) => {
    const frontLeftPosState = useMemo(() => {
        let offset = false;
        if((params.leanF_p_w && params.lean_p_w) < 9) {
            if((params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 < -params.p_w / 2 - 1) && (params.lean_p_pos + params.lean_p_d / 2 + 2.5 > params.p_d / 2 + 1)){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanF_p_pos, params.leanF_p_d, params.p_w, params.lean_p_pos, params.lean_p_d, params.p_d, params.leanF_p_w, params.lean_p_w])

    const backLeftPosState = useMemo(() => {
        let offset = false;
        if((params.leanB_p_w && params.lean_p_w) < 9) {
            if((params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 < -params.p_w / 2 - 1) && (params.lean_p_pos - params.lean_p_d / 2 - 2.5 < -(params.p_d / 2 + 1))){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanB_p_pos, params.leanB_p_d, params.p_w, params.lean_p_pos, params.lean_p_d, params.p_d, params.leanB_p_w, params.lean_p_w])

    const [arrowPositions, setArrowPositions] = useState({
        lengthArrowSize: 0,
        lengthArrowPos: [0, 0, 0],
        widthArrowSize: 0,
        leftWidthArrowPos: [0, 0, 0],
        rightWidthArrowPos: [0, 0, 0],
        heightArrowSize: 0,
        leftHeightArrowPos: [0, 0, 0],
        rightHeightArrowPos: [0, 0, 0],
    });

    const arrowOffset = 0.3;
    const offset = 0.2;

    useMemo(() => {
        const {
            p_w, lean_p_w, leanF_p_w, leanB_p_w, lean_p_d, lean_p_h, lean_p_pos,
            add_left_back_lean_porch, add_left_front_lean_porch,
        } = params;
        const alignPosOffset = 0;
        let newArrowPositions = {};

        if (add_left_back_lean_porch && !add_left_front_lean_porch) {
            newArrowPositions = {
                lengthArrowSize: lean_p_d + leanB_p_w + 0.6,
                lengthArrowPos: [-p_w / 2 - lean_p_w - offset, offset, -leanB_p_w / 2 + alignPosOffset],
                widthArrowSize: lean_p_w,
                leftWidthArrowPos: [-p_w / 2 - lean_p_w / 2 - offset, 0, -lean_p_d / 2 - arrowOffset + alignPosOffset],
                rightWidthArrowPos: [-p_w / 2 - lean_p_w / 2 - offset, 0, lean_p_d / 2 + arrowOffset + alignPosOffset],
                heightArrowSize: lean_p_h,
                leftHeightArrowPos: [-p_w / 2 - lean_p_w - offset, 0, lean_p_d / 2 + arrowOffset + alignPosOffset],
                rightHeightArrowPos: [-p_w / 2 - lean_p_w - offset, 0, -lean_p_d / 2 - leanB_p_w - arrowOffset + alignPosOffset],
            };
        } else if (!add_left_back_lean_porch && add_left_front_lean_porch) {
            newArrowPositions = {
                lengthArrowSize: lean_p_d + leanF_p_w + 0.6,
                lengthArrowPos: [-p_w / 2 - lean_p_w - offset, offset, leanF_p_w / 2 + alignPosOffset],
                widthArrowSize: lean_p_w,
                leftWidthArrowPos: [-p_w / 2 - lean_p_w / 2 - offset, 0, -lean_p_d / 2 - arrowOffset + alignPosOffset],
                rightWidthArrowPos: [-p_w / 2 - lean_p_w / 2 - offset, 0, lean_p_d / 2 + arrowOffset + alignPosOffset],
                heightArrowSize: lean_p_h,
                leftHeightArrowPos: [-p_w / 2 - lean_p_w - offset, 0, lean_p_d / 2 + leanF_p_w + arrowOffset + alignPosOffset],
                rightHeightArrowPos: [-p_w / 2 - lean_p_w - offset, 0, -lean_p_d / 2 - arrowOffset + alignPosOffset],
            };
        } else if (add_left_back_lean_porch && add_left_front_lean_porch) {
            newArrowPositions = {
                lengthArrowSize: lean_p_d + leanF_p_w + leanB_p_w + 0.6,
                lengthArrowPos: [-p_w / 2 - lean_p_w - offset, offset, alignPosOffset],
                widthArrowSize: lean_p_w,
                leftWidthArrowPos: [-p_w / 2 - lean_p_w / 2 - offset, 0, -lean_p_d / 2 - arrowOffset + alignPosOffset],
                rightWidthArrowPos: [-p_w / 2 - lean_p_w / 2 - offset, 0, lean_p_d / 2 + arrowOffset + alignPosOffset],
                heightArrowSize: lean_p_h,
                leftHeightArrowPos: [-p_w / 2 - lean_p_w - offset, 0, lean_p_d / 2 + leanF_p_w + arrowOffset + alignPosOffset],
                rightHeightArrowPos: [-p_w / 2 - lean_p_w - offset, 0, -lean_p_d / 2 - leanB_p_w - arrowOffset + alignPosOffset],
            };
        } else {
            newArrowPositions = {
                lengthArrowSize: lean_p_d + 0.6,
                lengthArrowPos: [-p_w / 2 - lean_p_w - offset, arrowOffset - 0.1, alignPosOffset],
                widthArrowSize: lean_p_w,
                leftWidthArrowPos: [-p_w / 2 - lean_p_w / 2 - offset, 0, -lean_p_d / 2 - arrowOffset + alignPosOffset],
                rightWidthArrowPos: [-p_w / 2 - lean_p_w / 2 - offset, 0, lean_p_d / 2 + arrowOffset + alignPosOffset],
                heightArrowSize: lean_p_h,
                leftHeightArrowPos: [-p_w / 2 - lean_p_w - offset, 0, lean_p_d / 2 + arrowOffset + alignPosOffset],
                rightHeightArrowPos: [-p_w / 2 - lean_p_w - offset, 0, -lean_p_d / 2 - arrowOffset + alignPosOffset],
            };
        }

        setArrowPositions(newArrowPositions);
    }, [
        params.p_w, params.p_d, params.lean_p_w, params.leanF_p_w, params.leanB_p_w,
        params.lean_p_d, params.lean_p_h, params.lean_p_pos, params.add_left_back_lean_porch,
        params.add_left_front_lean_porch, params.leantoAlignmentLeft
    ]);

    const {
        lengthArrowSize, lengthArrowPos, widthArrowSize,
        leftWidthArrowPos, rightWidthArrowPos, heightArrowSize,
        leftHeightArrowPos, rightHeightArrowPos
    } = arrowPositions;



    return params.add_left_lean && (
        <group name='Measurements-leftLeanto'>
            {/****** length ******/}
            <group name='front-arrow' position={lengthArrowPos} rotation={[0, Math.PI / 2, 0]}>
                <LineModel length={lengthArrowSize} rotation={[0, 0, Math.PI / 2]} color={color} />
                <DimensionValue position={[0, -0.2, -0.5]} rotation={[0, Math.PI, 0]} value={`${convertFeet((lengthArrowSize-0.6),false)} L`} slopeAngle={25} type={'lean'} cmpPos={lengthArrowPos} />
            </group>

            {/****** Width ******/}
            <group name='left-arrow' position={leftWidthArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={widthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[backLeftPosState ? 0: -0.4, backLeftPosState ? 1.5 : 0, 0]} rotation={[0, -Math.PI / 2, 0]} value={`${convertFeet(widthArrowSize,false)} W`} slopeAngle={backLeftPosState ? 0 : 25} type={'lean'} cmpPos={leftWidthArrowPos} />
            </group>
            <group name='right-arrow' position={rightWidthArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={widthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[frontLeftPosState ? 0: 0.4, frontLeftPosState ? 1.5 : 0, 0]} rotation={[0, Math.PI / 2, 0]} value={`${convertFeet(widthArrowSize,false)} W`} slopeAngle={frontLeftPosState ? 0 : 25} type={'lean'} cmpPos={rightWidthArrowPos} />
            </group>

            {/****** height ******/}
            <group name='right-arrow' position={leftHeightArrowPos}>
                <LineModel length={heightArrowSize - 0.2} position={[0, params.lean_p_h / 2 + 0.08, 0]} color={color} />
                <DimensionValue position={[-[...`${convertFeet(heightArrowSize)} H`].length * 0.2, params.lean_p_h / 2, -offset]} rotation={[0, 0, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={leftHeightArrowPos} />
            </group>
            <group name='left-arrow' position={rightHeightArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={heightArrowSize - 0.2} position={[0, params.lean_p_h / 2 + 0.08, 0]} color={color} />
                <DimensionValue position={[-[...`${convertFeet(heightArrowSize)} H`].length * 0.2, params.lean_p_h / 2, offset]} rotation={[0, Math.PI, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={rightHeightArrowPos} />
            </group>
        </group>
    );
};

export default LeftLeanToMeasurement;
